import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { CROSS_MESSAGE } from '../commons/utils/cross-origin-communication';

import usePortalSettings from './usePortalSettings';

const useTagManager = () => {
  const flags = useFlags();

  const { portalSettings } = usePortalSettings();

  const initialize = () => {
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line func-names
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  };

  const postGAMessage = (event, data) => {
    window.parent.postMessage(
      {
        type: CROSS_MESSAGE.HANDLE_GA,
        payload: {
          event,
          data: {
            ...data,
            page_title: 'NoFraud Checkout',
            page_location: window.location.href,
            event_id: Date.now(),
            send_to: data?.send_to || portalSettings.analytics.measurementID,
          },
        },
      },
      '*',
    );
  };

  const dataLayer = (response, paymentType = 'Credit card') => {
    if (!flags['disable-google-analytics'] && portalSettings.analytics.isEnabled) {
      const track = response.plugins?.analytics?.track;

      if (track) {
        const data = {
          currency: response.order.currency?.displayCurrency,
          value: response.order.total,
          items: track[2].items.map((item, index) => ({
            affiliation: track[2].affiliation,
            currency: response.order.currency?.displayCurrency,
            index,
            item_name: item.name,
            item_id: String(item.id),
            item_category: item.productType,
            item_category_2: item.category,
            price: item.price,
            quantity: item.quantity,
          })),
        };
        postGAMessage('add_shipping_info', data);

        data.payment_type = paymentType;
        postGAMessage('add_payment_info', data);

        data.transaction_id = response.order.platformOrderId;
        data.affiliation = track[2].affiliation;
        data.tax = response.order.tax;
        data.shipping = response.order.shipping;
        data.discount = response.order.discount;
        if (portalSettings?.analytics?.googleAds?.isEnabled) {
          postGAMessage('conversion', {
            send_to: `${portalSettings.analytics?.googleAds?.conversionID}/${portalSettings.analytics?.googleAds?.conversionLabel}`,
            value: response.order.total,
            currency: response.order.currency?.displayCurrency,
            transaction_id: response.order.platformOrderId,
          });
        }
        postGAMessage('purchase', data);
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  return { dataLayer, postGAMessage };
};

export default useTagManager;
